'use client'

import { useState } from 'react'
import { EmailStep } from '../EmailStep/EmailStep'
import { OtpStep } from '../OtpStep/OtpStep'
import { usePasswordlessLogin } from './usePasswordlessLogin'

export type LoginStep = 'email' | 'otp'

type PasswordlessLoginProps = {
  step?: LoginStep
  onSuccess: () => void
  onStepChange?: (step: LoginStep) => void
}

export function PasswordlessLogin({
  step: externalStep,
  onSuccess,
  onStepChange,
}: PasswordlessLoginProps) {
  const [internalStep, setInternalStep] = useState<LoginStep>('email')
  const step = externalStep ?? internalStep

  function stepChangeHandler(newStep: LoginStep) {
    setInternalStep(newStep)
    onStepChange?.(newStep)
  }

  const {
    email,
    isLoading,
    emailError,
    otpError,
    emailSubmitHandler,
    otpSubmitHandler,
    resendHandler,
    clearError,
  } = usePasswordlessLogin({ onSuccess, onStepChange: stepChangeHandler })

  function backHandler() {
    clearError()
    stepChangeHandler('email')
  }

  if (step === 'otp') {
    return (
      <OtpStep
        email={email}
        isLoading={isLoading}
        error={otpError}
        onSubmit={otpSubmitHandler}
        onResend={resendHandler}
        onBack={backHandler}
      />
    )
  }

  return (
    <EmailStep
      isLoading={isLoading}
      error={emailError}
      onSubmit={emailSubmitHandler}
    />
  )
}
